import React, { useEffect, useState } from 'react';
import { ConsultaLogs } from '../lib/api';
import Icon from './Icon';

export default function Logs() {
    const [logs, setLogs] = useState([]);
    const [sel, setSel] = useState(null);
    const [filtro, setFiltro] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => { reload(); }, []);

    async function reload() {
        setLoading(true);
        const resp = await ConsultaLogs({});
        setLoading(false);
        if (resp.Error) { setLogs([]); return; }
        const lista = Array.isArray(resp) ? resp : [];
        setLogs(lista);
    }

    const visiveis = logs.filter(l =>
        !filtro ||
        (l.feature || '').toLowerCase().includes(filtro.toLowerCase()) ||
        (l.acao || '').toLowerCase().includes(filtro.toLowerCase())
    );

    return (
        <div className="page">
            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num">05</span> Auditoria · {logs.length} eventos carregados</div>
                    <h1 className="page-title">Logs &amp; Histórico</h1>
                    <p className="page-sub">
                        Stream consolidado das últimas execuções. Selecione um evento à esquerda para ver detalhes à direita.
                        Arquivo: <span className="mono">/tibabita_scripts/Claude-code/CentralBabita-prod/backend/audit.log</span>
                    </p>
                </div>
                <div style={{ display: 'flex', gap: 10 }}>
                    <button className="btn ghost" onClick={reload}>
                        <Icon name="history" size={11}/> Recarregar
                    </button>
                    <button className="btn">
                        <Icon name="upload" size={11}/> Exportar .log
                    </button>
                </div>
            </div>

            <div className="log-shell">
                <div className="log-list">
                    <div className="log-filter">
                        <Icon name="search" size={13}/>
                        <input placeholder="Filtrar…" value={filtro} onChange={e => setFiltro(e.target.value)}/>
                    </div>
                    {loading && <div className="muted" style={{ padding: 16 }}>Carregando…</div>}
                    {visiveis.map((l, i) => (
                        <div
                            key={i}
                            className={`log-item ${sel === l ? 'active' : ''}`}
                            onClick={() => setSel(l)}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span className={`dot ${l.severidade || 'ok'}`}/>
                                <b>{l.feature}</b>
                                <span className="right mono" style={{ fontSize: 11, color: 'var(--ink-mute)' }}>{l.data || l.timestamp}</span>
                            </div>
                            <div className="muted" style={{ fontSize: 11, marginTop: 4, paddingLeft: 16 }}>{l.acao}</div>
                        </div>
                    ))}
                    {!loading && visiveis.length === 0 && <div className="muted" style={{ padding: 16 }}>Sem registros.</div>}
                </div>

                <div className="log-viewer">
                    {sel ? (
                        <>
                            <div className="log-line">
                                <span className="lvl-ok">[{sel.data || sel.timestamp}]</span> <b>{sel.feature}</b> · {sel.acao}
                            </div>
                            <div className="log-line" style={{ marginTop: 8 }}>solicitante: {sel.solicitante || '-'}</div>
                            {sel.args && (
                                <>
                                    <div className="log-line" style={{ marginTop: 14, opacity: .7 }}>Argumentos enviados:</div>
                                    <div className="log-line">{JSON.stringify(sel.args, null, 2)}</div>
                                </>
                            )}
                            {sel.detalhes && <div className="log-line" style={{ marginTop: 14 }}>{sel.detalhes}</div>}
                        </>
                    ) : <div style={{ opacity: .5 }}>Selecione um evento à esquerda para ver detalhes.</div>}
                </div>
            </div>
        </div>
    );
}
